/*@ngInject*/
const CreateCorrespondenceFormRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.createCorrespondenceForm = function (submissionId) {
        let url = '/rest/DocumentGeneration/createCorrespondenceForm',
            config = {
                params: {
                    submissionId: submissionId
                }
            };

        return this.post(url, {}, config);
    };

    this.createEmailCorrespondenceForm = function (submissionId) {
        let url = '/rest/Email/createCorrespondenceForm',
            config = {
                params: {
                    submissionId: submissionId
                }
            };

        return this.post(url, {}, config);
    };

    this.generateLetter = function (submissionId, formId) {
        let url = '/rest/DocumentGeneration/generateLetter',
            config = {
                params: {
                    submissionId: submissionId,
                    formId : formId
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('createCorrespondenceFormRepository', CreateCorrespondenceFormRepository);
